import { render } from "./ReporteRemitos.vue?vue&type=template&id=1ee7f98f&scoped=true"
import script from "./ReporteRemitos.vue?vue&type=script&lang=js"
export * from "./ReporteRemitos.vue?vue&type=script&lang=js"

import "./ReporteRemitos.vue?vue&type=style&index=0&id=1ee7f98f&scoped=true&lang=scss"

import exportComponent from "/builds/aplicaciones_mides/pat_qr/QRreader/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee7f98f"]])

export default __exports__